import * as React from 'react';

import { ConfirmationDialogSettings } from './component';

export const useConfirmationDialog = (
  setConfirmationDialogSettingsRef: React.MutableRefObject<
    ((current: ConfirmationDialogSettings) => void) | undefined
  >,
) => {
  const [confirmationDialogSettings, setConfirmationDialogSettings] =
    React.useState<ConfirmationDialogSettings>();

  React.useEffect(() => {
    setConfirmationDialogSettingsRef.current = setConfirmationDialogSettings;
  }, [setConfirmationDialogSettingsRef, setConfirmationDialogSettings]);

  const handleConfirm = React.useCallback(() => {
    setConfirmationDialogSettings((currentConfirmationDialogsSettings) => {
      if (currentConfirmationDialogsSettings) {
        currentConfirmationDialogsSettings.handler(true);
      }
      return undefined;
    });
  }, [setConfirmationDialogSettings]);

  const handleCancel = React.useCallback(() => {
    setConfirmationDialogSettings((currentConfirmationDialogsSettings) => {
      if (currentConfirmationDialogsSettings) {
        currentConfirmationDialogsSettings.handler(false);
      }
      return undefined;
    });
  }, [setConfirmationDialogSettings]);

  return { handleConfirm, handleCancel, confirmationDialogSettings };
};
